import React, { useEffect, useState } from 'react';
import instance from './axios';
import './Row.css';
import YouTube from 'react-youtube';
import movieTrailer from 'movie-trailer';

const base_url = "http://image.tmdb.org/t/p/original/"

function Row( {title, fetchUrl, isLarge } ) {
    const [movies, setMovies] = useState([]);
    const [trailerUrl, settrailerUrl] = useState("");

    useEffect(()=>{
        async function fetchData() {
            const request = await instance.get(fetchUrl);
            setMovies(request.data.results)
        }
        fetchData();
    }, [fetchUrl]);

    const opts = {
        height: '390',
        width: '100%',
        playerVars: {
          // https://developers.google.com/youtube/player_parameters
          autoplay: 1,
        },
      };

    // console.log(movies);

    const handleClick = (movie) =>{
        if(trailerUrl) {
            settrailerUrl('');
        }
        else {
            movieTrailer(movie?.name || movie?.title || movie?.original_name || "").then(
                (url) =>{
                    const urlParams = new URLSearchParams(new URL(url).search);
                    settrailerUrl(urlParams.get('v'));
                }
            ).catch((error)=>{console.log(error)});
        }
    }

    return(
        <div className='row'>
            <h2>{title}</h2>
            <div className= 'row_posters'>
            {movies.map(movie => (
                <img className = {`row_poster ${isLarge && 'row_posters_large'}`}
                src={`${base_url}${isLarge ? movie.poster_path : movie.backdrop_path}`}
                alt={movie.name} key={movie.id} 
                onClick={()=>handleClick(movie)}/>
            ))}
        </div>
        {trailerUrl && <YouTube videoId={trailerUrl} opts={opts} />}
        </div>
    )
}

export default Row;